// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DJAVG73aooRWXUBFeJZc{flex-direction:column;gap:24px;display:flex}.xWdZ1OhV2SMOT149tWUT{flex-direction:column;gap:4px;display:flex}.JRY2cSz5MaPWZwRIMd2U.JCXQJzBm8MIjRPAouANZ{margin-bottom:16px}.JRY2cSz5MaPWZwRIMd2U.i7qHGH4sW0oFPWmR2_k0{margin-bottom:8px}.cy_vuh2t_W4qZ3kijghG{flex-direction:column;gap:16px;display:flex}.RwmpXHW5kacdDGX6ApxO{flex-direction:column;gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `DJAVG73aooRWXUBFeJZc`,
	"header": `xWdZ1OhV2SMOT149tWUT`,
	"greetingHeader": `JRY2cSz5MaPWZwRIMd2U`,
	"full": `JCXQJzBm8MIjRPAouANZ`,
	"empty": `i7qHGH4sW0oFPWmR2_k0`,
	"content": `cy_vuh2t_W4qZ3kijghG`,
	"brunches": `RwmpXHW5kacdDGX6ApxO`
};
export default ___CSS_LOADER_EXPORT___;
